import styled from "styled-components";
import { theme } from "../../theme/GlobalTheme";


export const Container = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: ${theme.spacing.lg};
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  ${props => props.alignStart && `
    align-items: flex-start;
  `}
`;

export const ContentCard = styled.div`
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.large};
  box-shadow: ${theme.shadows.card};
  padding: ${theme.spacing.xl};
  width: 100%;
  max-width: 600px;
`;

export const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Input = styled.input`
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.md};
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  width: 100%;
  background-color: ${theme.colors.white};
  color: ${theme.colors.text};
  box-sizing: border-box;
  margin-bottom: ${theme.spacing.md};
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.secondary};
    box-shadow: 0px 0px 0px 2px rgba(194, 42, 144, 0.1);
  }
`;

export const Title = styled.h1`
  font-size: ${theme.typography.fontSize.h2};
  color: ${theme.colors.primary};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  margin: 0 0 ${theme.spacing.lg} 0;
  text-align: center;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #333;
  margin-bottom: 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.spacing.md};
  width: 100%;
  margin-top: 0;
`;

export const Button = styled.button`
  border: none;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  width: 100%;
  text-align: center;
  padding: 15px;
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  border-radius: ${theme.borderRadius.medium};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-top: ${theme.spacing.lg};

  &:hover {
    background-color: ${theme.colors.secondary};
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.light};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const BackButton = styled(Button)`
  background-color: ${theme.colors.white};
  color: ${theme.colors.primary};
  border: 1px solid ${theme.colors.primary};
  margin-right: ${theme.spacing.md};
  width: auto;
  flex: 1;

  &:hover {
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.light};
  }
`;

export const AdvancedSettings = styled.div`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  margin-top: 0;
  padding: ${theme.spacing.md} 0;
  border-top: 1px solid ${theme.colors.tertiary};
  border-bottom: 1px solid ${theme.colors.tertiary};
  margin-bottom: ${theme.spacing.md};
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const Label = styled.label`
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.textDark};
  margin-bottom: ${theme.spacing.sm};
  display: block;
  font-weight: ${theme.typography.fontWeight.bold};
  font-family: ${theme.typography.fontFamily};
`;

export const DropdownContainer = styled.div`
  margin-bottom: ${theme.spacing.md};
`;

export const Dropdown = styled.select`
  -webkit-appearance: none;
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.md};
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  width: 100%;
  background-color: ${theme.colors.white};
  color: ${theme.colors.text};
  box-sizing: border-box;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.secondary};
    box-shadow: 0px 0px 0px 2px rgba(194, 42, 144, 0.1);
  }
  
  &:hover {
    border-color: ${theme.colors.secondary};
  }
`;